import React from "react";
import Heading from "../../components/common/Typography/Heading";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { Link } from "react-router-dom";
import Paragraph from "../../components/common/Typography/Paragraph";
import SpecialText from "../../components/common/Typography/SpecialText";
import BlogDesign from "../../components/common/Blog/BlogDesign";
import {
  PUBLIC_BLOG_LAYOUT_COLUMN_GAP_CLASS,
  PUBLIC_SUBSECTION_HEADING_CLASS,
  PUBLIC_HELP_LINK_STACK_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_HEADING_TO_BODY_CLASS,
} from "../Public/shared/publicLayoutSpec";
const BlogsLayout = () => {
  const data = [
    {
      id: 1,
      item: "Interviews",
      link: "/blogs/category-name",
    },
    {
      id: 2,
      item: "Go green",
      link: "/blogs/category-name",
    },
    {
      id: 3,
      item: "DIY",
      link: "/blogs/category-name",
    },
    {
      id: 4,
      item: "Hang time",
      link: "/blogs/category-name",
    },
    {
      id: 5,
      item: "Trades update",
      link: "/blogs/category-name",
    },
  ];
  const bloggs = [
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
    {
      title:
        "The services that an architect typically provides include concept",
      text: "The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept The services that an architect typically provides include concept",
      time: "6 May, 2024",
    },
  ];
  return (
    <>
      <div className="w-full">
        <div className={`flex flex-col lg:flex-row ${PUBLIC_BLOG_LAYOUT_COLUMN_GAP_CLASS}`}>
          <div className="w-full flex flex-col items-start lg:mt-12">
            <AuxiliaryText
              variant={"MenuDropdown"}
              className={`${PUBLIC_SUBSECTION_HEADING_CLASS} text-offblack w-full font-semibold`}
            >
              All Categories
            </AuxiliaryText>
            {data.map((e) => {
              return (
                <Link to={e.link} key={e.id}>
                  <AuxiliaryText
                    variant={"SubMenuDropdown"}
                    className={`${PUBLIC_HELP_LINK_STACK_CLASS} hover:text-primaryblue`}
                  >
                    {e.item}
                  </AuxiliaryText>
                </Link>
              );
            })}
          </div>
          <div className="lg:w-[700px] xl:w-[900px] 2xl:w-[1050px] shrink-0">
            <Link to={"/blogs/article-id-will-be-here"} className="group block">
              <Heading variant={"h5"} className={"text-offblack group-hover:text-primaryblue transition-colors duration-200"}>
                8 tips for developing motion design principles
              </Heading>
              <div className={`lg:w-[700px] xl:w-[900px] 2xl:w-[1050px] h-[350px] sm:h-auto lg:h-[400px] xl:h-[600px] sm:aspect-[900/600] ${PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}`}>
                <img
                  src={require("../../../src/assets/img/default-image.jpg")}
                  className="w-full h-full shrink-0 object-cover rounded-xl"
                  alt=""
                />
              </div>
            </Link>
            <Paragraph
              variant={"MainParagraph"}
              className={`${PUBLIC_HEADING_TO_CONTENT_CLASS} text-offblack w-full`}
            >
              A casual space for the community to share their off-the-clock
              activities and informal gatherings. This category celebrates the
              lighter side of the trades community, from hobbies and interests
              to relaxation techniques, promoting a balanced lifestyle.
            </Paragraph>
            <SpecialText
              variant={"DateStamp"}
              className={`${PUBLIC_HEADING_TO_BODY_CLASS} text-offblack`}
            >
              7 days ago
            </SpecialText>

            {bloggs.map((e, index) => {
              return (
                <BlogDesign
                  key={index}
                  heading={e.title}
                  para={e.text}
                  timing={e.time}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsLayout;
